import { render, staticRenderFns } from "./abilityNew.vue?vue&type=template&id=1351be7a&scoped=true"
import script from "./abilityNew.vue?vue&type=script&lang=js"
export * from "./abilityNew.vue?vue&type=script&lang=js"
import style0 from "./abilityNew.vue?vue&type=style&index=0&id=1351be7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351be7a",
  null
  
)

export default component.exports